<template>
  <svg
    class="theme-icon svg-component"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="definition.viewBox"
    :fill="definition.fill || 'none'"
    :stroke="definition.stroke || 'none'"
    :stroke-width="definition.strokeWidth"
    :stroke-linecap="definition.strokeLinecap"
    :stroke-linejoin="definition.strokeLinejoin"
    :aria-hidden="decorative ? 'true' : undefined"
    :aria-label="decorative ? undefined : title || name"
    :role="decorative ? undefined : 'img'"
    focusable="false"
  >
    <title v-if="!decorative && title">{{ title }}</title>
    <template v-for="(node, index) in definition.nodes" :key="`${name}-${index}`">
      <circle v-if="node.tag === 'circle'" v-bind="node.attrs" />
      <line v-else-if="node.tag === 'line'" v-bind="node.attrs" />
      <path v-else-if="node.tag === 'path'" v-bind="node.attrs" />
      <polyline v-else-if="node.tag === 'polyline'" v-bind="node.attrs" />
      <rect v-else-if="node.tag === 'rect'" v-bind="node.attrs" />
    </template>
  </svg>
</template>

<script>
import { resolveThemeIcon } from '@/theming/iconRegistry'

export default {
  name: 'ThemeIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: ''
    },
    decorative: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    definition() {
      return resolveThemeIcon(this.name)
    }
  }
}
</script>

<style scoped>
.theme-icon {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}
</style>
